import React from 'react';
import { Link } from 'react-router-dom';
import  SimpleReactValidator from 'simple-react-validator';
import Preloader from '../../../core/Preloader';
import { viewData, processData } from '../../../core/HttpAction';
import {permissionCheck} from '../../../core/Permission';
import Nopermission from '../../../core/Nopermission';
const Url='/fine-setting';
const backUrl='/library'+Url;
 

class AddEditAction extends React.Component {
    constructor(props) {
        super(props); 
        this.state={
            name:'', 
            member_type:'',
            penalty_type: '',
            fine_amount: '',
            preloader:this.props.match.params.id?true:false,
            title:this.props.match.params.id?'Edit':'New'
        };
        this.validator = new SimpleReactValidator();
    }


    componentDidMount(){
        if(this.props.match.params.id){
            viewData(Url+'/'+this.props.match.params.id).then((res)=>{
                if(res.data.status===200){
                    let data=res.data.data;
                    this.setState({
                        name:data.title?data.title:'', 
                        member_type:data.member_type?data.member_type:'',
                        penalty_type:data.penalty_type?data.penalty_type:'',
                        fine_amount:data.fine_amount?data.fine_amount:'',status:data.status, 
                        preloader:false, 
                    });
                }
            });
        }
    }
 
    setStateFromInput=(event)=> {
        var obj = {};
        obj[event.target.name] = event.target.value;
        this.setState(obj);
    }

    submitForm=()=>{
        if( this.validator.allValid() ){
            let params={
                title:this.state.name,
                member_type:this.state.member_type,
                penalty_type:this.state.penalty_type,
                fine_amount:this.state.fine_amount
            };
            let para=this.props.match.params.id?'/'+this.props.match.params.id:'';
            processData(Url+para,params).then((res)=>{
                if(res.data.status===200){
                    this.props.history.push(backUrl);
                } else{
                    const msg =res.data.message?res.data.message:'Please enter required feilds...';                     alert(msg);
                    this.setState({error_status:true,preloader:false});
                }
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
 
  
    render() {
        let {title,preloader,member_type,penalty_type,fine_amount,status,name} = this.state;
        let role=permissionCheck('book',title);
        if(!role)
            return <Nopermission/>;
        const nameValid= this.validator.message('name', name, 'required');
        const member_typeValid= this.validator.message('member_type', member_type, 'required');
        const penalty_typeValid= this.validator.message('penalty_type', penalty_type, 'required');
        const fine_amountValid= this.validator.message('amount', fine_amount, 'required');
        return (
            <div id="page_content_inner" className="uk-width-medium-4-10 uk-container-center">
                <h3 className="heading_b uk-margin-bottom">{title} Fine Setting</h3>
                <div className="md-card">
                    <div className="md-card-content large-padding">
                        <div className="uk-grid" data-uk-grid-margin>
                            <div className="uk-width-medium-1-1"> 
                                <div className={ `md-input-wrapper ${this.state.name ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="name">Title<span className="req">*</span></label>
                                    <input type="text" name="name" value={this.state.name} onChange={this.setStateFromInput} className={ `md-input ${nameValid ?'md-input-danger':''}`} /> 
                                    {nameValid} 
                                </div>
                                <div className={ `md-input-wrapper ${member_type ? 'md-input-filled' : ''}`}>
                                    <select id="select_demo_1" className="md-input" name="member_type" onChange={this.setStateFromInput} value={member_type}>
                                        <option value="">select member</option>
                                        <option value="student">Student</option>
                                        <option value="staff">Staff</option> 
                                    </select> 
                                    {member_typeValid} 
                                </div>
                                <div className={ `md-input-wrapper ${penalty_type ? 'md-input-filled' : ''}`}>
                                    <select id="select_demo_1" className="md-input" name="penalty_type" onChange={this.setStateFromInput} value={penalty_type}>
                                        <option value="">select penalty type</option>
                                        <option value="fine">Fine</option>
                                        <option value="lost">Lost</option> 
                                    </select> 
                                    {penalty_typeValid} 
                                </div>
                                <div className={ `md-input-wrapper ${ fine_amount? 'md-input-filled' : ''}`}>
                                    <label htmlFor="name">Penalty Amount<span className="req">*</span></label>
                                    <input type="text" name="fine_amount" value={this.state.fine_amount} onChange={this.setStateFromInput} className={ `md-input ${fine_amountValid ?'md-input-danger':''}`} /> 
                                    {fine_amountValid} 
                                </div> 
                                <div className="md-input-wrapper md-radio">
                                    <span className="md-radio">
                                        <input checked={status==1?1:0} onChange={this.setStateFromInput} type="radio" name="status" id="radio_demo_1" value="0" />
                                        <label htmlFor="radio_demo_1" className="inline-label">Active</label>
                                        <input type="radio" name="status" id="radio_demo_2" checked={status==0?1:0} onChange={this.setStateFromInput} value="1" />
                                        <label htmlFor="radio_demo_2" className="inline-label">Inactive</label>
                                    </span>
                                </div> 
                            </div>
                        </div>
                        
                        <div className="uk-grid">
                            <div className="uk-width-1-1">
                                <Link to={backUrl} className="md-btn md-btn-danger md-btn-wave-light waves-effect waves-button waves-light">Cancel</Link>
                                <button type="button" onClick={this.submitForm} className="md-btn md-btn-primary md-btn-wave-light waves-effect waves-button waves-light">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
                { preloader && <Preloader/> }
            </div>  
        );
    }
}
 

export default AddEditAction;


// WEBPACK FOOTER //
// ./src/components/Library/FineSetting/addEdit.js